import Vue from "vue";
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    imagecropperShow: false,
    imagecropperEmail: '',
    user: {},
    viewingAs: null,
    clientChannelId: localStorage.getItem('clientChannelId'),
    clientUserName: localStorage.getItem('clientUserName'),
    clientUserAccount: localStorage.getItem('clientUserAccount'),
    techUserId: localStorage.getItem('techUserId'),
    techUserName: localStorage.getItem('techUserName'),
    techSlackId: localStorage.getItem('techSlackId'),
    companyId: localStorage.getItem('companyId'),
    sidebarOpened: !!+localStorage.getItem('sidebarStatus'),
    sideBarStatus: true,
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setImagecropperShow(state, imagecropperShow) {
      state.imagecropperShow = imagecropperShow;
    },
    setImagecropperEmail(state, imagecropperEmail) {
      state.imagecropperEmail = imagecropperEmail;
    },
    setViewingAs(state, viewingAs) {
      state.viewingAs = viewingAs;
    },
    setCompanyId(state, companyId) {
      localStorage.setItem('companyId', companyId);
      state.companyId = companyId;
    },
    setClientUserAccount(state, clientUserAccount) {
      localStorage.setItem('clientUserAccount', clientUserAccount);
      state.clientUserAccount = clientUserAccount;
    },
    setClientChannelId(state, clientChannelId) {
      localStorage.setItem('clientChannelId', clientChannelId);
      state.clientChannelId = clientChannelId;
    },
    setClientUserName(state, clientUserName) {
      localStorage.setItem('clientUserName', clientUserName);
      state.clientUserName = clientUserName;
    },
    setTechUserId(state, techUserId) {
      localStorage.setItem('techUserId', techUserId);
      state.techUserId = techUserId;
    },
    setTechUserName(state, techUserName) {
      localStorage.setItem('techUserName', techUserName);
      state.techUserName = techUserName;
    },
    setTechSlackId(state, techSlackId) {
      localStorage.setItem('techSlackId', techSlackId);
      state.techSlackId = techSlackId;
    },
    toggleSidebar(state) {
      if(!state.sideBarStatus) return;
      localStorage.setItem('sidebarStatus', !state.sidebarOpened ? 1 : 0);
      state.sidebarOpened = !state.sidebarOpened
    },
    closeSidebar(state) {
      localStorage.setItem('sidebarStatus', 1);
      state.sidebarOpened = 1
    },
    setSidebarStatus(state, sideBarStatus) {
      state.sideBarStatus = sideBarStatus
    }
  },
  actions: {
    LogOut({ commit }) {
      localStorage.clear();
      commit('setUser', null);
      commit('setViewingAs', null);
      commit('setClientUserAccount', '');
      commit('setClientChannelId', '');
      commit('setClientUserName', '');
      commit('setTechUserName', '');
      commit('setTechSlackId', '');
    }
  }
})

export default store;